webpackJsonp([55702396619907],{

/***/ 440:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"group":[{"fieldValue":"Corning","totalCount":1},{"fieldValue":"Drs","totalCount":1},{"fieldValue":"New York","totalCount":1},{"fieldValue":"Partner","totalCount":1},{"fieldValue":"SUNY","totalCount":1},{"fieldValue":"test","totalCount":2}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-c4f31ee06c010e78d78d.js